
<div class="card profile-eduction " *ngIf="ShowList">
  <div class="card-body padding-tb padding-right margin-left-zero">

    <div class="row">
      <div class="col-md-12 padding-all-0px margin-left-zero">
        <!--<h6 class="panel-title fb">Education Info</h6>-->
        <div class="table-component">
          <div class="table-responsive">
            <table class="table  profile-table margin-left-zero">
              <!--<thead class="profile-thead ">
                <tr>
                  <th scope="col">Specialty</th>
                  <th scope="col"> Duration</th>

                  <th scope="col"></th>

                </tr>
              </thead>-->
              <tbody>
                <tr *ngFor="let l of CurrentActorSpecialtyInfoController">
                  <td>
                    <div class="row margin-left-zero">
                      <label class="font-size-14px margin-bottom-0px"> {{l.Specialty}}</label>
                    </div>
                    <div class="row margin-left-zero">
                      <label class="font-size-11px margin-bottom-0px">{{l.TotalDurationText}}</label>
                    </div>
                  </td>
                  

                  <td >
                    <div class="row">
                      <a (click)="edit_(l)" class="nav-link-hand education-navlink margin-left-auto" *ngIf="CanEdit === 1 ">
                        <span class="badge"><i class="fas fa-pencil-alt color-edit-icon"></i></span>
                      </a>
                      <a (click)="del2_(l)" class="nav-link-hand education-navlink color-delete-icon" *ngIf="CanEdit === 1 ">
                        <span class="badge">
                          <i class="far fa-trash-alt"></i>
                        </span>
                      </a>
                    </div>
                  </td>
                </tr>

              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
    
  </div>

    <!--<div class="row">
      <div class="col-md-12 col-xs-12 mt-2 mb-4 text-right add-but">
        <button type="button" (click)="ExpandData()" class="btn btn-primary btn-sm"><i class="fas round-plus"></i>Expand</button>
      </div>
    </div>-->
    <div *ngIf='IsExpand'>
      <div class="row" *ngIf="ShowList">
        <div class="col-md-12 col-xs-12 mt-2 mb-4 text-right add-but addnew">
          <button type="button" (click)="clearData()" class="btn btn-primary btn-sm margin-right-39px"><!--<i class="fas fa-plus nav-link-hand"> </i>--> Add New</button>
        </div>
      </div>
      <div *ngIf='isNew && !ShowList'>
        <form class="form" novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">

          <div class="comon-box profile-box p-0 margin-left-18px">
            <h4 class="heading-pinkbg mt-0">Add Specialty</h4>
            <div class="row pl-3 pr-3 margin-left-zero">


              <div class="form-group col-md-4 col-xs-12">
                <label for="eventInput2">Specialty</label>
                <CodeTypeValue CodeType="SPECI" id="CurrentActorSpecialtyRequest.Specialty"
                               [(ngModel)]="CurrentActorSpecialtyRequest.Specialty" SelectedValue=""
                               name="CurrentActorSpecialtyRequest.Specialty" #InstituteType="ngModel"></CodeTypeValue>

              </div>

              <div class="form-group col-md-4 col-xs-12">
                <label for="eventInput2">Years of Experience<span>*</span></label>
                <input type="number" class="form-control" id="CurrentActorSpecialtyRequest.DurationY"
                       [(ngModel)]="CurrentActorSpecialtyRequest.DurationY" pattern="^[\0-9]*$"
                       name="CurrentActorSpecialtyRequest.DurationY" placeholder="Years" maxlength="2" #DurationY="ngModel">
                <!--<small class="form-text text-danger"
                       *ngIf="(!DurationY.valid && (DurationY.dirty || DurationY.touched))"></small>

                <small class="form-text text-danger"
                       *ngIf="(!DurationY.valid && DurationY.errors.pattern)">(special characters are not allowed)</small>-->
              </div>

              <div class="form-group col-md-4 col-xs-12">
                <label for="eventInput2">Months of Experience<span>*</span></label>
                <input type="number" class="form-control" id="CurrentActorSpecialtyRequest.DurationM"
                       [(ngModel)]="CurrentActorSpecialtyRequest.DurationM" pattern="^[\0-9]*$"
                       name="CurrentActorSpecialtyRequest.DurationM" placeholder="Months"  maxlength="2" #DurationM="ngModel">
                <!--<small class="form-text text-danger"
                       *ngIf="(!DurationM.valid && (DurationM.dirty || DurationM.touched))"></small>

                <small class="form-text text-danger"
                       *ngIf="(!DurationM.valid && DurationM.errors.pattern)">(special characters are not allowed)</small>-->
              </div>

           


              <br /><br /><br /><br /><br />

            </div>


          </div>
          
          <div class="row margin-right" *ngIf="CanEdit === 1 ">
            <div class="card-footer text-right col-12">
              <button (click)="CancelNewOperation()" *ngIf='!isRequesting' class="btn actions-btn-prime nav-link-hand button-Schedule actions-btn-prime3">Cancel</button>
              <button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn actions-btn-prime nav-link-hand">Save</button>




            </div>
          </div>

        </form>
      </div>
      <div *ngIf='isEdit && !ShowList'>
        <form class="form" novalidate="" (ngSubmit)="onEditSubmit()" #f="ngForm">

          <div class="comon-box p-0 margin-left-zero margin-left-18px">
            <h4 class="heading-pinkbg mt-0">Update Specialty:{{CurrentActorEditSpecialtyInfoRequest.Specialty}}</h4>
            <div class="row pl-3 pr-3 margin-left-zero">




              <!--<div class="form-group col-md-4 col-xs-12">
                <label for="eventInput2"></label>
              </div>-->

              <div class="form-group col-md-4 col-xs-12">
                <label for="eventInput2">Years of Experience<span>*</span></label>
                <input type="text" class="form-control" id="CurrentActorEditSpecialtyInfoRequest.DurationY"
                       [(ngModel)]="CurrentActorEditSpecialtyInfoRequest.DurationY" pattern="^[\0-9]*$"
                       name="CurrentActorEditSpecialtyInfoRequest.DurationY" placeholder="Years" maxlength="2" #DurationY="ngModel">
                <!--<small class="form-text text-danger"
                       *ngIf="(!DurationY.valid && (DurationY.dirty || DurationY.touched))"></small>

                <small class="form-text text-danger"
                       *ngIf="(!DurationY.valid && DurationY.errors.pattern)">(special characters are not allowed)</small>-->
              </div>

              <div class="form-group col-md-4 col-xs-12">
                <label for="eventInput2">Months of Experience<span>*</span></label>
                <input type="text" class="form-control" id="CurrentActorEditSpecialtyInfoRequest.DurationM"
                       [(ngModel)]="CurrentActorEditSpecialtyInfoRequest.DurationM" pattern="^[\0-9]*$"
                       name="CurrentActorEditSpecialtyInfoRequest.DurationM" placeholder="Months" maxlength="2" #DurationM="ngModel">
                <!--<small class="form-text text-danger"
                       *ngIf="(!DurationM.valid && (DurationM.dirty || DurationM.touched))"></small>

                <small class="form-text text-danger"
                       *ngIf="(!DurationM.valid && DurationM.errors.pattern)">(special characters are not allowed)</small>-->
              </div>

 
              <!--<div class="card-footer pink-bg text-right" *ngIf="CanEdit === 1 ">
    <button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn actions-btn-prime">Update</button>

  </div>-->
              <br /> <br /><br /><br /><br />
            </div>


          </div>


          <div class="row margin-right" *ngIf="CanEdit === 1 ">
            <div class="card-footer text-right col-12">

              <button (click)="CancelUpdateOperation()" *ngIf='!isRequesting' class="btn button-Schedule actions-btn-prime nav-link-hand actions-btn-prime3">Cancel</button>
              <button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn actions-btn-prime nav-link-hand">Update</button>


            </div>
          </div>




        </form>
      </div>
    </div>


    <!--<div class="row">
      <div class="form-group col-md-12 col-xs-12 mt-5"><a href="#finish" role="menuitem" class="btn-blue-main">Save</a></div>
    </div>-->
